import { gql } from '@apollo/client';

const joinSealantQuery = gql`query getSealantPage($language: String!) {
  items: nodeQuery(filter: {conditions: [{operator: EQUAL, field: "type", value: "sealant_page"}, {operator: EQUAL, field: "status", value: "1"}, {operator: EQUAL, field: "langcode", value: [$language]}]}) {
    joinSealantPage: entities {
      ... on NodeSealantPage {
        nid
        title
        fieldImage {
          entity {
            ...imageFragment
          }
        }
        fieldProductBlocTitle
        fieldTitleCertificate
        fieldTitleRelatedCleaners
        products: queryFieldProducts(limit: 50) {
          entities {
            ... on NodeProductJointSealant {
              entityId
              title
              nid
              fieldLink
              fieldPackagingSealant{
                entity {
                  ...packageFragment
                }
              }
              fieldRelatedProducts {
                uri
                title
                options
              }
              body {
                summary
                value
              }
              fieldImage {
                entity {
                  ...imageFragment
                }
              }
              fieldTitleBackerRod
              fieldCertificate {
                value
                format
                processed
              }
            }
          }
        }
        fieldProductCtaText
        fieldBackerRodPackageLabel
        fieldNoBackerRodPackageLabe
        fieldJointTypeBlocTitle
        fieldSquareJointLabel
        fieldTriangleJointLabel
        fieldTriangleJointPicto {
          entity {
            ...imageFragment
          }
        }
        fieldSquareJointPicto {
          entity {
            ...imageFragment
          }
        }
        fieldJointDimensionBlocTitle
        fieldDimensionWidthLabel
        fieldDimensionDepthLabel
        fieldTrianglePictoText {
          entity {
            ...imageFragment
          }
        }
        fieldSquarePictoTxt {
          entity {
            ...imageFragment
          }
        }
        fieldLenghtBlocTitle
        fieldLengthLabel
        fieldLengthPictoWithText {
          entity {
            ...imageFragment
          }
        }
        fieldCalculateButtonLabel
        fieldCalculateButtonDesc
        fieldResultBlocTitle
        fieldResultProductCtaLabel
        fieldCartrigeLabel
        fieldChooseLabel
        fieldInactiveButtonLabel
        fieldDisclaimer
        fieldErrorMsgProduct
        fieldErrorMsgPackaging
        fieldErrorMsgJointType
        fieldErrorMsgJointDim
        fieldErrorMsgTotalLength
      }
    }
  }
}
fragment imageFragment on MediaImage {
  name
  thumbnail {
    url
    alt
  }
  fieldMediaImage {
    entity {
      url
    }
  }
}
fragment packageFragment on TaxonomyTermJointSealantPackaging {
  name
  tid
  fieldMetricImperial
  fieldAdditionalInformations
  fieldQuantity
  fieldPackagingType {
    entity {
      entityLabel
      entityId
    }
  }
}`;

export default joinSealantQuery;
